import { typography, size } from '@everlywell/leaves';
import styled from 'styled-components';

// what element should this be?
export const Headline = styled.p`
  ${typography.h2Text};
  margin-bottom: ${size.xl4}px;
`;
